import axios from 'axios'
import { SERVER_API_URL_PARTNER } from '../config/constants'

export const apiPartnerCreateUserPartner = (params: any) => axios.post(SERVER_API_URL_PARTNER + '/partner/auth/register', params)
